module.exports = __webpack_public_path__ + "img/white-check.b4bfef55.svg";